/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/display-name */
// TODO: Fix accessibility
// TODO: Fix display name

import './filter-button-dropdown.component.scss';
import {
  DetailedHTMLProps,
  HTMLAttributes,
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  Button,
  ButtonGroup,
  Dropdown,
  Form,
  ListGroup,
  OverlayTrigger,
  Spinner,
} from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  FILTER_TYPES,
  Filter,
} from '../../../../hooks/filters/interfaces/filter.interface';
import { useAppAsyncFilterOptions } from '../../../../hooks/filters/use-app-filter-options.hook';
import { setValue } from '../../../../services/get-filters.service';
import { IMAGES_REPO } from '../../../../static-resources';
import { DescriptorsComponent } from '../../../descriptor/descriptor.component';
import { getIdClassNameHelper } from '../../helpers/get-id-class-name.helper';
import { hasFilterSelectedValue } from '../../hooks/common.hook';
import { FilterButtonComponentProps } from './filter-button-dropdown.component';

interface FilterButtonMenuComponentProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  label: string;
  isFetching?: boolean;
}

export const FilterToggleButtonComponent = forwardRef<
  HTMLDivElement,
  FilterButtonMenuComponentProps
>(({ children, className, style, onClick }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      style={style}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(e);
      }}
    >
      <div className="filter-toggle-button-input">
        <div className="filter-toggle-button-text">{children}</div>
      </div>
    </div>
  );
});

interface CheckBoxItemComponentProps {
  option: FilterOptionSelectedValue;
  isSelected: boolean;
  multiple: boolean;
}
const CheckBoxItemComponent = ({
  isSelected,
  option,
  multiple,
}: CheckBoxItemComponentProps) => {
  if (multiple) {
    return (
      <div className="">
        <div className="checkbox">
          <div
            className={`checkbox-container checkbox${isSelected ? '-selected' : '-unselected'}`}
          >
            {isSelected && <img src={IMAGES_REPO.CheckIcon} alt="" />}
          </div>

          <label className="form-check-label">{option.label}</label>
        </div>
        <DescriptorsComponent metadata={option.metadata} />
      </div>
    );
  } else {
    return (
      <div className="form-check-label">
        {option.label}
        <DescriptorsComponent metadata={option.metadata} />
      </div>
    );
  }
};
interface MenuItemProps {
  selectedValue?: FilterSelectedValue;
  option: FilterOptionSelectedValue;
  onChange(selectedOptionValue: FilterOptionSelectedValue): void;
  multiple: boolean;
  disabled?: boolean;
}

const MenuItem = ({
  selectedValue,
  option,
  onChange,
  multiple,
  disabled,
}: MenuItemProps) => {
  const isSelected = useMemo(() => {
    return (
      selectedValue?.values.find((j) => j.value === option.value) !== undefined
    );
  }, [selectedValue, option]);

  return (
    <Dropdown.Item
      disabled={disabled}
      onClick={() => onChange(option)}
      className={`${isSelected ? 'filter-dropdown-component-item-active' : ''} ${getIdClassNameHelper(option.value)}`}
    >
      <CheckBoxItemComponent
        isSelected={isSelected}
        option={option}
        multiple={multiple}
      />
    </Dropdown.Item>
  );
};
export interface FilterButtonDropdownBasicComponentProps
  extends FilterButtonComponentProps {
  setSelectedValue: (selectedValue: FilterSelectedValue) => void;
  selectedValue: FilterSelectedValue | undefined;
}

const validate = (selValue: FilterSelectedValue, filter: Filter) => {
  if (filter.required && selValue?.values.length === 0) {
    return 'Required';
  } else {
    return null;
  }
};

export const FilterButtonDropdownBasicComponent = ({
  onSelect,
  filter,
  filterSelection,
  variant = '',
  searchBox = true,
  defaultLabel = 'All',
  disabled,
  disabledOptions,
  selectedValue,
  setSelectedValue,
}: FilterButtonDropdownBasicComponentProps) => {
  const multiple = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_MULTIPLE ||
      filter.type === FILTER_TYPES.MULTIPLE,
    [filter],
  );
  const isSingle = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_SINGLE ||
      filter.type === FILTER_TYPES.SINGLE,
    [filter],
  );
  const isAsync = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_MULTIPLE ||
      filter.type === FILTER_TYPES.ASYNC_SINGLE,
    [filter],
  );

  const [search, setSearch] = useState<string | undefined | null>(
    isAsync ? undefined : null,
  );
  const { options, isFetching } = useAppAsyncFilterOptions(
    filter.id,
    filterSelection,
    search,
  );

  const [selValue, setSelValue] = useState<FilterSelectedValue | undefined>();
  const [error, setError] = useState<string | null>(null);
  const [selectChange, setSelectChange] = useState<boolean | undefined>();

  const applyFilterCallback = useCallback(
    (selValue: FilterSelectedValue) => {
      if (validate(selValue, filter) === null && selValue) {
        setSelValue(selValue);
        setSelectedValue(selValue);
        setSearch(undefined);
        setSelectChange(true);
      }
      if (onSelect) {
        onSelect(selValue);
      }
    },
    [setSelectedValue, setSelValue, filter, onSelect],
  );

  useEffect(() => {
    const selVal1 = hasFilterSelectedValue(selectedValue);
    const selVal2 = hasFilterSelectedValue(selValue);
    if (
      selVal1 &&
      selVal2 &&
      selVal1.values[0].value === selVal2.values[0].value &&
      selectChange !== undefined
    ) {
      setSelectChange(undefined);
    }
  }, [selectedValue, selValue, selectChange]);

  useEffect(() => {
    if (selectedValue) {
      setSelValue({ ...selectedValue });
    }
  }, [selectedValue]);

  const changeValueHandler = useCallback(
    (selectedOptionValue: FilterOptionSelectedValue) => {
      if (selValue) {
        const values = [
          {
            value: selectedOptionValue.value,
            label: selectedOptionValue.label,
          },
        ];
        const val: FilterSelectedValue = { ...selValue, values };
        // TODO: Check if this is intentional
        if (filter.required && values.length === 0) {
          /* empty */
        } else {
          applyFilterCallback(val);
        }
      }
    },
    [selValue, filter, applyFilterCallback],
  );

  const changeMultipleValueHandler = useCallback(
    (selectedOptionValue: FilterOptionSelectedValue) => {
      if (selValue) {
        const existingValues = selValue.values;
        const found = existingValues.find(
          (i) => i.value === selectedOptionValue.value,
        );
        let values = [];
        if (found) {
          values = existingValues.filter(
            (i) => i.value !== selectedOptionValue.value,
          );
        } else {
          values = existingValues.concat([
            {
              value: selectedOptionValue.value,
              label: selectedOptionValue.label,
            },
          ]);
        }
        const val: FilterSelectedValue = { ...selValue, values };
        setSelValue(val);
      }
    },
    [selValue],
  );

  const onClickHandler = useCallback(() => {
    setSearch(null);
  }, []);

  const [searchValue, setSearchValue] = useState<string>('');
  useEffect(() => {
    if (!searchValue) {
      setSearch(null);
      return;
    }

    if (searchValue.trim() === '') {
      setSearch(null);
    } else {
      if (searchValue.trim().length > 4) {
        setSearch(searchValue);
      } else {
        setSearch(null);
      }
    }
  }, [searchValue]);

  const filterFunc = useCallback(
    (option: FilterOptionSelectedValue) => {
      if (searchValue === '' || !searchBox) return true;
      const val = hasFilterSelectedValue(selectedValue);
      if (val) {
        const found = val.values.find((i) => i.value === option.value);
        if (found) return true;
      }
      if (
        option.metadata?.descriptors &&
        option.metadata?.descriptors?.length > 0
      ) {
        const descriptors: string[] = option.metadata.descriptors;
        const found = descriptors.find(
          (i) => i.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1,
        );
        if (found) return true;
        const completeDesc = descriptors.join(' : ');
        return (
          completeDesc.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
        );
      }
      return (
        option.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
      );
    },
    [selectedValue, searchValue, searchBox],
  );

  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);

  const onToggleCallback = useCallback(
    (isOpen: boolean) => {
      if (selValue && multiple && isOpen === false) {
        applyFilterCallback(selValue);
        setSearch(undefined);
      }
      setIsOpen(isOpen);
    },
    [selValue, multiple, applyFilterCallback],
  );

  const clearFilter = useCallback(() => {
    if (selValue) {
      const v = { ...selValue, values: [] };
      if (isOpen === true) {
        setIsOpen(false);
        setValue(v);
      } else {
        applyFilterCallback(v);
        setSearch(undefined);
      }
    }
  }, [selValue, isOpen, applyFilterCallback]);

  const apply = useCallback(() => {
    if (selValue) {
      applyFilterCallback(selValue);
    }
    setIsOpen(false);
    setSearchValue('');
  }, [selValue, applyFilterCallback]);

  const cancel = useCallback(() => {
    if (selectedValue) {
      setSelValue({ ...selectedValue });
    }
    setIsOpen(false);
    setSearchValue('');
    setSelectChange(true);
  }, [selectedValue]);

  const clear = useCallback(() => {
    if (selValue) {
      const v = { ...selValue, values: [] };
      setSelValue(v);
    }
    setSearch(null);
    setSearchValue('');
    setSelectChange(true);
  }, [selValue]);

  useEffect(() => {
    if (filter.required && selValue?.values.length === 0) {
      setError(`Required`);
    } else {
      setError(null);
    }
  }, [selValue, filter]);

  const showTooltip = useMemo(() => {
    return (selectedValue?.values && selectedValue?.values.length > 1) ||
      (selectedValue?.values &&
        selectedValue?.values.length === 1 &&
        selectedValue?.values[0].label &&
        selectedValue?.values[0].label.length > 20)
      ? true
      : false;
  }, [selectedValue]);

  const label = useMemo(() => {
    return selectedValue?.values && selectedValue?.values.length === 1
      ? selectedValue?.values[0].label
      : selectedValue?.values && selectedValue?.values.length > 1
        ? 'Multiple Selected'
        : defaultLabel;
  }, [selectedValue, defaultLabel]);

  return (
    <Dropdown
      className={`${getIdClassNameHelper(filter.id)} filter-button-dropdown-${variant} ${disabled ? 'filter-button-dropdown-disabled' : ''}`}
      as={ButtonGroup}
      onClick={() => onClickHandler()}
      autoClose={isSingle ? true : 'outside'}
      onToggle={onToggleCallback}
      show={isOpen}
      aria-disabled={disabled}
    >
      <div className="filter-toggle-button-label">
        {filter.name}&nbsp;
        {isFetching && (
          <Spinner
            className="filter-toggle-button-spinner"
            animation="border"
            size="sm"
            role="status"
          />
        )}
      </div>

      <Dropdown.Toggle
        className="filter-toggle-button"
        id={filter?.id}
        as={FilterToggleButtonComponent}
        label={filter.name}
        isFetching={isFetching}
        disabled={disabled}
      >
        {showTooltip && (
          <OverlayTrigger
            placement="auto-end"
            overlay={() => (
              <div className="filter-button-dropdown-tooltip">
                {selectedValue?.values &&
                  selectedValue?.values.length > 0 &&
                  selectedValue?.values.map((i, index) => (
                    <ListGroup.Item key={index}>{i.label}</ListGroup.Item>
                  ))}
              </div>
            )}
          >
            <div>
              {label}
              &nbsp;
            </div>
          </OverlayTrigger>
        )}

        {!showTooltip && (
          <div>
            {label}
            &nbsp;
          </div>
        )}
      </Dropdown.Toggle>

      {!filter.required && selValue?.values && selValue?.values.length > 0 && (
        <div
          className="filter-toggle-button-clear"
          onClick={() => !disabled && clearFilter()}
        >
          <X size="sm" />
        </div>
      )}

      <Dropdown.Menu className="filter-button-dropdown" show={isOpen}>
        <div className="d-flex gap-2">
          {searchBox && (
            <Form.Control
              autoFocus
              className="filter-button-dropdown-search-input"
              placeholder={`Search ${filter.name}...`}
              onChange={(e: any) => setSearchValue(e.target.value)}
              value={searchValue}
              disabled={disabled}
            />
          )}
          {multiple && (
            <Button
              variant="sm"
              className="btn"
              onClick={() => clear()}
              disabled={disabled}
            >
              Clear
            </Button>
          )}
        </div>
        <div className="filter-button-dropdown-menu">
          {options?.filter &&
            options
              ?.filter(filterFunc)
              .map((i) => (
                <MenuItem
                  key={i.value}
                  multiple={multiple}
                  selectedValue={selValue}
                  option={i}
                  onChange={
                    multiple ? changeMultipleValueHandler : changeValueHandler
                  }
                  disabled={
                    disabledOptions?.find((x) => x === i.value) !== undefined ||
                    i.disabled === true ||
                    disabled
                  }
                />
              ))}
        </div>
        {multiple && (
          <div className="filter-button-dropdown-footer d-flex gap-2">
            <div className="filter-button-dropdown-footer-cancel">
              <Button
                variant="sm"
                className="btn"
                onClick={() => cancel()}
                disabled={disabled}
              >
                Cancel
              </Button>
            </div>
            <div className="filter-button-dropdown-footer-apply">
              <Button
                variant="sm"
                className="btn-primary"
                disabled={error !== null || disabled}
                onClick={() => apply()}
              >
                Apply
              </Button>
            </div>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
